import React from 'react';
import { Search, Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { Link } from 'react-router-dom';
export function OrderSearch() {
  const orders = [{
    id: 1001,
    orderNumber: 'ORD-2023-001',
    products: 'Desert Ecology Basics',
    subtotal: '$49.00',
    status: 'Processed',
    customer: 'John Doe',
    date: '2023-10-15',
    total: '$49.00'
  }, {
    id: 1002,
    orderNumber: 'ORD-2023-002',
    products: 'Advanced Water Conservation',
    subtotal: '$79.00',
    status: 'Failed',
    customer: 'Alice Smith',
    date: '2023-10-16',
    total: '$79.00'
  }, {
    id: 1003,
    orderNumber: 'ORD-2023-003',
    products: 'Sustainable Landscaping',
    subtotal: '$39.00',
    status: 'Not Finished',
    customer: 'Bob Wilson',
    date: '2023-10-17',
    total: '$39.00'
  }];
  return <div className="space-y-6" data-id="element-580">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-581">Order Search</h1>

      <Card className="p-4" data-id="element-582">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end" data-id="element-583">
          <Select label="Date" options={[{
          value: 'all',
          label: 'All Dates'
        }, {
          value: 'today',
          label: 'Today'
        }, {
          value: 'week',
          label: 'This Week'
        }, {
          value: 'month',
          label: 'This Month'
        }]} data-id="element-584" />
          <Select label="Coupon" options={[{
          value: '',
          label: 'All Coupons'
        }, {
          value: 'SUMMER23',
          label: 'SUMMER23'
        }, {
          value: 'WELCOME',
          label: 'WELCOME'
        }]} data-id="element-585" />
          <Select label="Reseller" options={[{
          value: '',
          label: 'All Resellers'
        }, {
          value: '1',
          label: 'Partner A'
        }]} data-id="element-586" />
          <Button variant="secondary" className="gap-2" data-id="element-587">
            <Search className="h-4 w-4" data-id="element-588" />
            Search
          </Button>
        </div>
      </Card>

      <Card className="overflow-hidden" data-id="element-589">
        <div className="overflow-x-auto" data-id="element-590">
          <table className="w-full text-sm text-left" data-id="element-591">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-592">
              <tr data-id="element-593">
                <th className="px-4 py-3 w-10" data-id="element-594">
                  <input type="checkbox" className="rounded border-slate-300" data-id="element-595" />
                </th>
                <th className="px-4 py-3" data-id="element-596">Order Number</th>
                <th className="px-4 py-3" data-id="element-597">Products</th>
                <th className="px-4 py-3" data-id="element-598">Subtotal</th>
                <th className="px-4 py-3" data-id="element-599">Status</th>
                <th className="px-4 py-3" data-id="element-600">Customer Name</th>
                <th className="px-4 py-3" data-id="element-601">Date</th>
                <th className="px-4 py-3" data-id="element-602">Total</th>
                <th className="px-4 py-3" data-id="element-603">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-604">
              {orders.map(order => <tr key={order.id} className="hover:bg-slate-50" data-id="element-605">
                  <td className="px-4 py-3" data-id="element-606">
                    <input type="checkbox" className="rounded border-slate-300" data-id="element-607" />
                  </td>
                  <td className="px-4 py-3 font-medium" data-id="element-608">{order.orderNumber}</td>
                  <td className="px-4 py-3" data-id="element-609">{order.products}</td>
                  <td className="px-4 py-3" data-id="element-610">{order.subtotal}</td>
                  <td className="px-4 py-3" data-id="element-611">
                    <select defaultValue={order.status} className="text-xs rounded border-slate-300 py-1" data-id="element-612">
                      <option value="Failed" data-id="element-613">Failed</option>
                      <option value="Processed" data-id="element-614">Processed</option>
                      <option value="Not Finished" data-id="element-615">Not Finished</option>
                    </select>
                  </td>
                  <td className="px-4 py-3" data-id="element-616">{order.customer}</td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-617">{order.date}</td>
                  <td className="px-4 py-3 font-semibold" data-id="element-618">{order.total}</td>
                  <td className="px-4 py-3" data-id="element-619">
                    <Link to={`/custom/orders/print_order/${order.id}`} target="_blank" data-id="element-620">
                      <Button variant="ghost" size="sm" className="gap-2" data-id="element-621">
                        <Printer className="h-3 w-3" data-id="element-622" />
                        Print Order
                      </Button>
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}